import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}issues/forOrder`;

export interface IssueWithProductsSummary {
  id: string;
  name?: string;
  uniqueName?: string;
  key?: string;
  displayOrder: number;
}

export interface GetIssuesForOrderQueryArgs {
  orderId: string;
  ignoreDateRulesChecking: boolean;
}

export const getIssuesForOrderRequest = ({
  orderId,
  ignoreDateRulesChecking,
}: GetIssuesForOrderQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(
    `${ENDPOINT}/${orderId}`,
    { ignoreDateRulesChecking },
    { encode: false, arrayFormat: 'brackets' },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getIssuesForOrderQuery = async (
  args: GetIssuesForOrderQueryArgs,
): Promise<BackResponse<IssueWithProductsSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<IssueWithProductsSummary[]>>(
      getIssuesForOrderRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
